import { ReactNode } from "react";
import {
  createProfileAnnouncementsURL,
  createProfileDMsURL,
  createProfileFancardsURL,
  createProfileLinksURL,
  createProfileSharesURL,
  createProfileTagsURL,
  createProfilePageURL,
} from "#lib/urls";
import { Creator } from "#api/creators";
import routes from "#lib/routes";
import { NavLink } from "react-router";

interface IProps {
  creator: Creator;
}

interface ITabProps {
  href: string;
  children: ReactNode;
}

const announcementServices = ["fanbox", "patreon"];
const tagServices = ["fanbox", "patreon", "onlyfans", "fansly", "candfans"];

export function Tabs({ creator }: IProps) {
  return (
    <ul className="tabs">
      <Tab
        href={String(createProfilePageURL({ service: creator.service, creatorId: creator.id }))}
      >
        Posts
      </Tab>

      {creator.service !== "fanbox" ? undefined : (
        <Tab
          href={String(createProfileFancardsURL(creator.service, creator.id))}
        >
          Fancards
        </Tab>
      )}

      {!announcementServices.includes(creator.service) ? undefined : (
        <Tab
          href={String(createProfileAnnouncementsURL(creator.service, creator.id))}
        >
          Announcements
        </Tab>
      )}

      {!tagServices.includes(creator.service) ? undefined : (
        <Tab
          href={String(createProfileTagsURL(creator.service, creator.id))}
        >
          Tags
        </Tab>
      )}

      {!creator.dm_count ? undefined : (
        <Tab
          href={String(createProfileDMsURL(creator.service, creator.id))}
        >
          DMs ({creator.dm_count})
        </Tab>
      )}

      {!creator.share_count ? undefined : (
        <Tab
          href={String(createProfileSharesURL(creator.service, creator.id))}
        >
          Uploads ({creator.share_count})
        </Tab>
      )}

      {creator.has_chats ? (
        <Tab
          href={routes.communityChannelList(creator.id)}
        >
          Community
        </Tab>
      ) : undefined}

      <Tab
        href={String(createProfileLinksURL(creator.service, creator.id))}
      >
        {!creator.relation_id ? <>Linked Accounts</> : <>Linked Accounts (✔️)</>}
      </Tab>
    </ul>
  );
}

function Tab({ href, children }: ITabProps) {
  return (
    <li className="tab">
      <NavLink className={({ isActive }) => isActive ? "active" : ""} to={href} end={true}>
        {children}
      </NavLink>
    </li>
  );
}
